import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { ModalController, NavController } from '@ionic/angular';
import { UserService } from '../../../../shared/state/user/user.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { Observable } from 'rxjs';
import { MessageInitializaterComponent } from '../../../../shared/components/message-initializer-components/message-initializer-component';
import { MessageDetailQuery } from '../../../../shared/state/message-detail/message-detail.query';
import { MessageDetailService } from '../../../../shared/state/message-detail/message-detail.service';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { MessageService } from 'src/app/shared/state/message/message.service';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { RouterService } from '../../../../core/services/router/router.service';
import { fade_in, fade_out } from 'src/app/core/animations/fade';

@Component({
    selector: 'app-message-detail',
    animations: [fade_in, fade_out],
    templateUrl: './message-detail.component.html',
    styleUrls: ['./message-detail.component.scss'],
})
export class MessageDetailComponent
    extends MessageInitializaterComponent
    implements OnInit, OnDestroy {
    systemKeyUrl$: Observable<string>;
    clinicDetailId$: Observable<string>;

    /** Flowwwer template */
    @Input() messageID = null;
    @Input() isModal = false;
    constructor(
        clinicDetailQuery: ClinicDetailQuery,
        companyService: CompanyService,
        activatedRoute: ActivatedRoute,
        settingsService: SettingsService,
        clinicDetailService: ClinicDetailService,
        navCtrl: NavController,
        userService: UserService,
        settingsQuery: SettingsQuery,
        userQuery: UserQuery,
        messageDetailQuery: MessageDetailQuery,
        messageDetailService: MessageDetailService,
        routerService: RouterService,
        private router: Router,
        private callNumber: CallNumber,
        private messageService: MessageService,
        private modalController: ModalController
    ) {
        super(
            activatedRoute,
            settingsService,
            userService,
            companyService,
            clinicDetailService,
            navCtrl,
            clinicDetailQuery,
            settingsQuery,
            userQuery,
            messageDetailQuery,
            messageDetailService,
            routerService
        );
    }

    async ngOnInit(): Promise<void> {
        this.systemKeyUrl$ = this.settingsQuery.select('systemKeyURL');
        this.clinicDetailId$ = this.clinicDetailQuery.select('id');
        this.isLoadingContent = true;
        try {
            if (!this.isModal) {
                await this.initializeCompanyClinicUserMessage();
            } else {
                this.message$ = this.messageDetailQuery.select();
                this.messageSuscription$ = this.messageDetailQuery
                    .select()
                    .subscribe((data) => {
                        this.message = data;
                    });
                await this.messageDetailService.getMessage(this.messageID);
            }
            await this.messageService.getMessages(null);
        } catch (error) {
            this.isLoadingContent = false;
        }

        this.isLoadingContent = false;
    }

    /**  */
    ifConditionLeft(): boolean {
        return (this.message.promotionText1 !== '' ||
            this.message.promotionText2 !== '' ||
            this.message.promotionText3 !== '' ||
            this.message.promotionText4 !== '') &&
            this.message.promotionText5 === ''
            ? true
            : false;
    }

    ifConditionRight(): boolean {
        return (this.message.promotionText1 === '' ||
            this.message.promotionText2 === '' ||
            this.message.promotionText3 === '' ||
            this.message.promotionText4 === '') &&
            this.message.promotionText5 !== ''
            ? true
            : false;
    }

    messageActionButton() {
        switch (this.message.buttonAction) {
            /** Vamos a pedir cita */
            case 'S':
                this.clinicDetailService.updateOpenAppointmentWizard(true);
                this.router.navigate([
                    this.settingsQuery.systemKeyURL +
                        '/' +
                        this.clinicDetailQuery.id +
                        '/appointment',
                ]);
                break;
            /** Vamos a llamar */
            case 'C':
                this.callNumber
                    .callNumber(this.clinicDetailQuery.phone, true)
                    .then((res) => console.log('Launched dialer!', res))
                    .catch((err) => console.log('Error launching dialer', err));
                break;
            default:
                break;
        }
    }

    async openUrl(link) {
        if (Capacitor.isNativePlatform()) {
            await Browser.open({ url: link });
        } else {
            const win = window.open(link, '_blank');
            win.focus();
        }
    }

    /** Al destruir el componente nos desuscribimos al observable de los parámetros de esta página */
    ngOnDestroy() {
        if (!this.isModal) {
            this.unsuscribeParamsQueryParams();
        } else {
            this.messageSuscription$.unsubscribe();
        }
        this.messageDetailService.resetStore();
    }

    closeMessageDetail() {
        if (!this.isModal) {
            const { systemKeyURL } = this.settingsQuery.getValue();
            const { id } = this.clinicDetailQuery.getValue();

            this.router.navigate([systemKeyURL, id, 'message']);
        } else {
            this.modalController.dismiss({
                dismissed: true,
            });
        }
    }
}
